// packages/brand-config/brands/exx/index.ts
import type { BrandConfig } from "../../src/types";
import { createInitBrandTheme } from "../../src/initBrandThemeWithLocale";
import { createBrandAssetUrls } from "../../src/brandAssetUrls";
import meta from "./brand.json";
import theme from "./theme.json";

export const brandConfig: BrandConfig = {
  meta: meta as BrandConfig["meta"],
  tokens: theme as BrandConfig["tokens"],
  /** 构建时 webpack 将 ./assets 拷贝至 /brand-assets/exx/；logo.ico 另拷贝为站点根 /favicon.ico */
  assets: createBrandAssetUrls("exx", { logoExtension: "png" }),
};

export const initBrandTheme = createInitBrandTheme(brandConfig);

export { brandConfig as default };
